import { MatDateFormats } from '@angular/material/core';

// @Injectable({
// 	providedIn: 'root',
// })
// export class DateAdapterForMaterial extends NativeDateAdapter {
// 	constructor(private readonly cmDate: CmDatePipe, @Inject(MAT_DATE_LOCALE) private readonly matDateLocale: string) {
// 		super(matDateLocale);
// 	}

// 	format(date: Date, displayFormat: 'input' | Intl.DateTimeFormatOptions): string {
// 		if (displayFormat === 'input') {
// 			return this.cmDate.transform(date);
// 		}
// 		return date.toLocaleDateString('default', displayFormat);
// 	}
// }

export const DATE_FNS_CM_FORMATS: MatDateFormats = {
	parse: {
		dateInput: 'yyyy-MM-dd',
		timeInput: 'hh:mm a',
	},
	display: {
		dateInput: 'yyyy-MM-dd',
		monthYearLabel: 'yyyy-MM',
		dateA11yLabel: 'yyyy-MM-dd',
		monthYearA11yLabel: 'yyyy-MM/me ',
		timeInput: 'hh:mm a',
		timeOptionLabel: 'hh:mm a',
	},
};
